import { MonthPlanList } from "modules/finances";
import { Title } from "modules/layout";
import { useMyPermissions } from "modules/my-permissions";
import Link from "next/link";
import Router, { useRouter } from "next/router";
import FinancesEducationPage from "pages/[company]/finances/education/index.page";
import TableOfContentPage from "pages/[company]/finances/education/table-of-content.page";
import FinancesFundingRequestsPage from "pages/[company]/finances/funding-requests/index.page";
import pages from "pages/_router";
import React, { useMemo } from "react";
import { api } from "shared/api";
import { Button } from "shared/ui";
import { CompanyFinancesLayout } from "./_layout";

export const FinancesPlansPage = () => {
  const companySlug = useRouter().query.company as string;
  const monthPlanList = api.monthPlan.useMonthPlanList(companySlug);

  const settings = api.financeSettings.useFinanceSettingsGet(companySlug);

  const financialPlans = api.financialPlan.useFinancialPlanList(companySlug);
  const draftFinancialPlan = financialPlans.data?.find((it) => it.status === "DRAFT" || it.status === "ON_APPROVAL");
  const draftMonthPlan = api.monthPlan.useMonthPlanGet(companySlug, draftFinancialPlan?.monthPlanId!);
  const approvedPlans = useMemo(
    () =>
      monthPlanList.data?.filter((it) => it.status === "APPROVED" || it.status === "APPROVED_AND_HAS_FINANCIAL_PLAN"),
    [monthPlanList.data]
  );

  const nextFPResp = api.financialPlanCommon.useFinancialPlanCommonNextFinancialPlan(companySlug);

  const onCreate = async () => {
    const resp = await api.financialPlan.financialPlanCreate(companySlug);
    await Router.push(pages.company(companySlug).finances.yearMonth(resp.year, resp.month).results.id(resp.id).href);
  };

  const hasExpired = !!monthPlanList.data?.find((it) => it.weeks.find((it) => !it.closed && it.to < new Date()));

  const permissions = useMyPermissions(companySlug);

  if (settings.data?.education) {
    if (settings.data.educationStep !== 0) {
      return <TableOfContentPage />;
    }

    return <FinancesEducationPage />;
  }

  if (!permissions) return <CompanyFinancesLayout />;

  if (!permissions.finances.budgets.read) {
    return <FinancesFundingRequestsPage />;
  }

  return (
    <CompanyFinancesLayout>
      <Title
        actions={
          permissions?.finances.plannings.write &&
          approvedPlans?.length! > 0 && (
            <>
              {!draftFinancialPlan && nextFPResp.data && (
                <Button type={"secondary"} onClick={onCreate}>
                  Провести планирование
                </Button>
              )}
              {draftFinancialPlan && draftMonthPlan.data && (
                <Link
                  href={
                    pages
                      .company(companySlug)
                      .finances.yearMonth(draftMonthPlan.data.year, draftMonthPlan.data.month)
                      .results.id(draftFinancialPlan.id).href
                  }
                >
                  <Button>Продолжить планирование</Button>
                </Link>
              )}
            </>
          )
        }
      >
        Месячные бюджеты
      </Title>

      <MonthPlanList companySlug={companySlug} {...monthPlanList} />
    </CompanyFinancesLayout>
  );
};

export default FinancesPlansPage;
